import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import withStyles from 'react-jss';
import { isEmpty, every } from 'lodash';
import classNames from 'classnames';
import {
  getOnboardingState,
  getTenantState,
  getEcapState,
} from '../../../../../store/selectors';
import CloseIconMinus from '../../../../utility/CloseIconMinus';
import PlusIcon from '../../../../utility/PlusIcon';
import { setEcap, saveEcap } from '../../../../../store/actions';
import {
  getYearListStyleGrey,
  getYearListStyleWhite,
  getRequiredClassesBySubject,
  getRequiredClassesByAcadPlan,
  getSubjectId,
  isRecommendedClass,
  getAriaLabelForClass,
} from '../dragDropUtil';
import BookIcon from '../../../../utility/BookIcon';
import ClassPopUp from '../ClassPopUp';

const customInputStyles = {
  customClass: () => ({
    '&::placeholder': {
      color: 'black',
      opacity: 1,
    },
  }),
};

function ClassSlotMobile(props) {
  const {
    subjectEn,
    rowIndex,
    index,
    tenant,
    toggleSearch,
    currentDegree,
    currentDegreeReq,
    showPlan,
    removeClass,
    editCustomClass,
    placedClassesProp,
  } = {
    ...props,
  };

  const placedClasses = placedClassesProp;

  const subjectId = getSubjectId(subjectEn);

  const currentSubjectRequiredClasses = () =>
    getRequiredClassesBySubject(subjectId, props.currentDegreeReq);

  const checkIsRecommended = (hsClass, recommendationIndex) => {
    const arrayOfRequiredClassTitles = currentSubjectRequiredClasses().map(
      (eachClass) => eachClass.titleEn
    );
    return isRecommendedClass(
      hsClass,
      recommendationIndex,
      arrayOfRequiredClassTitles
    );
  };

  const textInput = useRef();

  let recommendationIndex = [];

  if (currentDegreeReq) {
    recommendationIndex = currentSubjectRequiredClasses()
      .filter((eachClass) => eachClass.year === index + 1)
      .map((eachClass) => eachClass.titleEn || 'elective');
    if (isEmpty(recommendationIndex)) recommendationIndex = ['Elective'];
  } else {
    recommendationIndex = ['Elective'];
  }

  const primaryColor = {
    background: `${tenant.primary}`,
  };

  const primaryBorder = {
    border: `1px solid ${tenant.primary}`,
  };

  const goldBorder = {
    border: '2px solid #fcc776',
  };

  const greenBorder = {
    border: '2px solid #51c27b',
  };

  const highlightBorder = (hsClass) => {
    if (hsClass) {
      return checkIsRecommended(hsClass, recommendationIndex)
        ? greenBorder
        : goldBorder;
    }

    return true;
  };

  const openSpeechBubble = (hsClass) => {
    const id = hsClass.requirement_title
      ? hsClass.requirement_title
      : hsClass.titleEn;

    document.getElementById(id).style.display = 'flex';
  };

  const handleCloseIconClick = (arrKey, spotIndex = 0) => {
    return removeClass(arrKey, spotIndex, null);
  };

  const handleCustomClassEditMobile = (
    e,
    hsClass,
    customSubject,
    year,
    customIndex
  ) => {
    if (textInput.current) {
      textInput.current.blur();
      const oldClass = JSON.parse(JSON.stringify(hsClass));
      const subjectYearId = `${customSubject}_${year}`;
      oldClass.titleEn = e.target.value;

      editCustomClass(subjectYearId, customIndex, oldClass);
    }
  };

  const handleClickOutside = () => {
    placedClasses[`${subjectEn}_${index}`].forEach((hsClass) => {
      if (hsClass) {
        if (
          document.getElementById(hsClass.requirement_title || hsClass.titleEn)
        ) {
          if (
            document.getElementById(
              hsClass.requirement_title || hsClass.titleEn
            ).style.display === 'flex'
          ) {
            document.getElementById(
              hsClass.requirement_title || hsClass.titleEn
            ).style.display = 'none';
          }
        }

        if (
          document.getElementById(hsClass.titleEn || hsClass.requirement_title)
        ) {
          if (
            document.getElementById(
              hsClass.titleEn || hsClass.requirement_title
            ).style.display === 'flex'
          ) {
            document.getElementById(
              hsClass.titleEn || hsClass.requirement_title
            ).style.display = 'none';
          }
        }
      }
    });
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const blankSubjectCard = (isHalfClass, eachClass, spotIndex) => {
    return (
      <div
        key={`blank-class-${eachClass}`}
        className={`subject-slot ${isHalfClass ? 'half' : null}`}
      >
        <div className="mobile-class-placeholder">
          <div className="subject-container">
            <p className="truncated-class-text-classlist">{eachClass}</p>
          </div>
          <button
            onClick={() => toggleSearch(true, subjectEn, spotIndex)}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key))
                toggleSearch(true, subjectEn, spotIndex);
            }}
            disabled={props.disabled}
            type="button"
            tabIndex="0"
            id="add-class-button-mobile"
            style={primaryColor}
            className={`class-button ${isHalfClass ? 'plus half' : null}`}
            name="search for class"
            aria-label={`Add class to ${props.subject} year ${
              props.index + 1
            }. Recommended class: ${
              recommendationIndex.length > 1
                ? recommendationIndex.join(' or ')
                : recommendationIndex[0]
            }`}
          >
            <PlusIcon />
          </button>
        </div>
      </div>
    );
  };

  const acadPlanClasses = () => {
    return props.acadPlanClasses;
  };

  const requiredClassesPerDroppable = () => {
    const requiredAcadPlanClasses = getRequiredClassesByAcadPlan(
      currentDegree.acadPlan,
      acadPlanClasses()
    );
    const tempClasses = requiredAcadPlanClasses
      .filter((eachClass) => eachClass.year === index + 1)
      // Need to add 1 to rowindex because of 0 indexing
      .filter((eachClass) => eachClass.academic_area_id === rowIndex + 1);

    return tempClasses;
  };

  const renderPlaceholderCard = (spotText, spotIndex) => {
    const isHalfClass = requiredClassesPerDroppable().length > 1;

    return blankSubjectCard(isHalfClass, spotText, spotIndex);
  };

  const propsIndex = props.index;
  const propsSubjectEn = props.subjectEn;

  const renderCard = (hsClass, classIndex = null) => {
    const isHalf =
      placedClasses[`${propsSubjectEn}_${propsIndex}`].length > 1 ||
      currentSubjectRequiredClasses.length > 1;
    return (
      <div
        key={hsClass.requirement_title || hsClass.titleEn}
        className={classNames({
          'subject-slot': true,
          half: isHalf,
        })}
      >
        <div style={{ position: 'relative' }}>
          <BookIcon
            color={tenant.primary}
            openSpeechBubble={openSpeechBubble}
            hsClass={hsClass}
            closeClassPopUp={handleClickOutside}
            ariaLabel={getAriaLabelForClass(recommendationIndex, hsClass)}
          />
          <div
            id={
              hsClass.requirement_title
                ? hsClass.requirement_title
                : hsClass.titleEn
            }
            style={{ display: 'none' }}
            className="bubble-class-indicator sb9-class-indicator mobile"
          >
            <ClassPopUp
              hsClass={hsClass}
              showCautionIcon={checkIsRecommended(hsClass, recommendationIndex)}
              recommendedClass={
                recommendationIndex.length > 1
                  ? recommendationIndex.join(' or ')
                  : recommendationIndex[0]
              }
            />
          </div>
        </div>
        <div className="mobile-class-placeholder">
          {/* TODO: Check if this is a custom class so we can edit it again */}
          <div
            className="class-container"
            style={showPlan ? highlightBorder(hsClass) : primaryBorder}
          >
            {hsClass.academic_area_id === 'Custom' ? (
              <input
                type="text"
                aria-hidden="true"
                ref={textInput}
                className={[
                  'truncated-class-text custom-year-column mobile',
                  props.classes.customClass,
                ].join(' ')}
                placeholder={hsClass.requirement_title || hsClass.titleEn}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key))
                    handleCustomClassEditMobile(
                      e,
                      hsClass,
                      subjectEn,
                      propsIndex,
                      classIndex
                    );
                }}
                onBlur={(e) => {
                  if (e.target.value !== '') {
                    handleCustomClassEditMobile(
                      e,
                      hsClass,
                      subjectEn,
                      propsIndex,
                      classIndex
                    );
                  }
                }}
              />
            ) : (
              <p>{hsClass.requirement_title || hsClass.titleEn}</p>
            )}
          </div>
          <div
            onClick={() =>
              handleCloseIconClick(`${subjectEn}_${propsIndex}`, classIndex)
            }
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key))
                handleCloseIconClick(`${subjectEn}_${propsIndex}`, classIndex);
            }}
            role="button"
            tabIndex="0"
            style={primaryColor}
            className={classNames({
              'class-button': true,
              minus: true,
              half: isHalf,
            })}
            disabled={props.disabled}
            aria-label={`Remove ${
              hsClass.titleEn || hsClass.requirement_title
            } from year ${propsIndex + 1}`}
          >
            <CloseIconMinus />
          </div>
          <div
            onClick={() => toggleSearch(true, subjectEn, classIndex)}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key))
                toggleSearch(true, subjectEn, classIndex);
            }}
            role="button"
            tabIndex="0"
            style={primaryColor}
            disabled={props.disabled}
            className={classNames({
              'class-button': true,
              plus: true,
              half: isHalf,
            })}
            id="add-class-button-mobile"
            aria-label={`Add class to ${props.subject} year ${
              props.index + 1
            }. Recommended class: ${
              recommendationIndex.length > 1
                ? recommendationIndex.join(' or ')
                : recommendationIndex[0]
            }`}
            name="search for class"
          >
            <PlusIcon />
          </div>
        </div>
      </div>
    );
  };

  const draggableExists =
    (placedClasses[`${subjectEn}_${index}`] &&
      placedClasses[`${subjectEn}_${index}`].length === 2) ||
    (recommendationIndex && recommendationIndex.length > 1);

  const handleNullPlaceholder = (firstNullIndex) => {
    if (requiredClassesPerDroppable()) {
      const placedClassesCopy = JSON.parse(
        JSON.stringify(placedClasses[`${propsSubjectEn}_${propsIndex}`])
      );
      placedClassesCopy[firstNullIndex] =
        requiredClassesPerDroppable()[firstNullIndex].titleEn ||
        requiredClassesPerDroppable()[firstNullIndex].requirement_title;

      return placedClassesCopy;
    }
  };

  const droppableSpots = () => {
    if (
      isEmpty(placedClasses[`${propsSubjectEn}_${propsIndex}`]) ||
      every(
        placedClasses[`${propsSubjectEn}_${propsIndex}`],
        (placedClass) => placedClass === null
      )
    ) {
      if (isEmpty(requiredClassesPerDroppable())) return ['Elective'];
      const tempReturn = requiredClassesPerDroppable().map(
        (eachClass) => eachClass.requirement_title || eachClass.titleEn
      );

      return tempReturn;
    }

    const firstNullIndex = placedClasses[
      `${propsSubjectEn}_${propsIndex}`
    ].findIndex((placedClass) => !placedClass);
    if (firstNullIndex >= 0) {
      return handleNullPlaceholder(firstNullIndex);
    }

    return placedClasses[`${propsSubjectEn}_${propsIndex}`];
  };
  return (
    <div
      key={index}
      className={
        draggableExists ? 'year-column-extended-mobile' : 'year-column-mobile'
      }
      style={
        rowIndex % 2 !== 0 ? getYearListStyleGrey() : getYearListStyleWhite()
      }
    >
      {droppableSpots().map((spotText, spotIndex) => {
        const placedClass =
          placedClasses[`${propsSubjectEn}_${propsIndex}`][spotIndex];
        /* eslint-disable react/no-array-index-key */
        return (
          <React.Fragment key={`class-${propsSubjectEn}-${spotIndex}`}>
            {placedClass
              ? renderCard(placedClass, spotIndex)
              : renderPlaceholderCard(spotText, spotIndex)}
          </React.Fragment>
        );
        /* eslint-enable react/no-array-index-key */
      })}
    </div>
  );
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);
  const ecap = getEcapState(state);

  return { onboarding, tenant, ecap };
};

export default withRouter(
  connect(mapStateToProps, { setEcap, saveEcap })(
    withStyles(customInputStyles)(ClassSlotMobile)
  )
);
